module.exports = {
  whitelist: ["/workflow/disposeForMiniProgram", "/workflow/view"],
};
